import { Environment } from './environment.model';

export function useEnvironment(): Environment {
  return (window as any).environment;
}

export function setWindowEnvironment(environment: Environment): void {
  (window as any).environment = environment;
}

/**
 * Načte JSON soubor a vrátí objekt nebo `null`, pokud soubor neexistuje.
 */
export async function tryLoadJson(path: string): Promise<Environment | null> {
  try {
    const response = await fetch(path);
    if (!response.ok) throw new Error();
    return await response.json();
  } catch {
    console.warn(`Config not found: ${path}`);
    return null;
  }
}

/**
 * Rekurzivně sloučí dvě konfigurace – hodnoty z `override` přepíšou ty v `base`.
 */
export function mergeDeep<T>(base: T, override: Partial<T>): T {
  const result = { ...base } as Record<string, any>;

  const baseObj = base as Record<string, any>;
  const overrideObj = override as Record<string, any>;

  for (const key of Object.keys(overrideObj)) {
    if (overrideObj[key] && typeof overrideObj[key] === 'object' && !Array.isArray(overrideObj[key])) {
      result[key] = mergeDeep(baseObj[key] ?? {}, overrideObj[key]);
    } else {
      result[key] = overrideObj[key];
    }
  }

  return result as T;
}

export async function loadEnvironment(): Promise<Environment> {
  const defaultConfig = await tryLoadJson('/config/environment.json');
  if (!defaultConfig) {
    throw new Error('Soubor environment.json nebyl nalezen.');
  }

  const localConfig = await tryLoadJson('/config/environment.local.json');
  return localConfig ? mergeDeep(defaultConfig, localConfig) : defaultConfig;
}
